import React from "react";
import { LinkContainer } from "react-router-bootstrap";
import {
  Container,
  Nav,
  Navbar,
  NavDropdown,
  Button,
  Row,
  Col,
  Modal,
  Form,
} from "react-bootstrap";
import { BsPhone } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { MdHandyman, MdContacts, MdPersonSearch } from "react-icons/md";
import { IoCreateOutline } from "react-icons/io5";
import { logout } from "../../actions/userActions";
import { BsCheckSquareFill } from "react-icons/bs";
import img from "./analysis.png";
import finecartLogo from "./finecart-logo.png";
import emailjs from "@emailjs/browser";
import "./about.css";
import { useState } from "react";

/* import '../index.css' */

const AboutUs = () => {
  const dispatch = useDispatch();
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [number, setNumber] = useState("");
  const [email, setEmail] = useState("");
  const [area, setArea] = useState("");
  const [modalShow, setModalShow] = React.useState(false);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const logoutHandler = () => {
    dispatch(logout());
  };

  const templateParams = {
    first_name: fname,
    last_name: lname,
    number: number,
    email: email,
    message: area,
    reply_to: email,
  };
  /* ----------------This is secrate key & service key & api key of email JS   */
  const submitHandler = () => {
    emailjs
      .send(
        "service_xhu1ho6",
        "template_wnpvbfi",
        templateParams,
        "Qi_k9iuIm8Yl8D4sT"
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
        },
        (err) => {
          console.log("FAILED...", err);
        }
      );
    setModalShow(true);
  };

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        style={{ color: "#000" }}
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header style={{ backgroundColor: "white" }} closeButton>
          <Modal.Title
            style={{ color: "#01584d" }}
            id="contained-modal-title-vcenter"
          >
            Email Sent Successfully <BsCheckSquareFill />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "white" }}>
          <h4>Our team member will contact you soon</h4>
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "white" }}>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <div style={{ backgroundColor: "#EDEDEd" }}>
      <header
        className="headerShadow enhanced-header"
        style={{ position: "sticky", top: "0", zIndex: "2" }}
      >
        <Navbar
          className="navbar-fixed-top"
          variant="dark"
          expand="md"
          collapseOnSelect
          style={{ backgroundColor: "#01584d" }}
        >
          <Container>
            <LinkContainer to="/">
              <Navbar.Brand className="enhanced-brand finecart-wordmark">
                <img
                  src={finecartLogo}
                  alt="finecart logo"
                  className="finecart-logo-img"
                />
                finecart
                <sup className="finecart-tm">™</sup>
              </Navbar.Brand>
            </LinkContainer>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className=" mr-auto enhanced-navbar-nav">
                <Nav.Link href="#home" className="enhanced-nav-link">
                  <IoCreateOutline /> Create Store
                </Nav.Link>
                <Nav.Link href="#about" className="enhanced-nav-link">
                  <MdPersonSearch /> About Us
                </Nav.Link>
                <Nav.Link href="#service" className="enhanced-nav-link">
                  <MdHandyman /> Service
                </Nav.Link>

                <Nav.Link href="#contact" className="enhanced-nav-link">
                  <MdContacts /> Contact
                </Nav.Link>
              </Nav>
              <Nav className="enhanced-navbar-nav ms-auto">
                {userInfo ? (
                  <NavDropdown className="enhanced-dropdown" title={userInfo.name} id="username">
                    <LinkContainer to="/profile">
                      <NavDropdown.Item>
                        <i className="fas fa-user-circle"></i> Profile
                      </NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer to="/myorders" id="myorders">
                      <NavDropdown.Item>
                        <i className="fas fa-list"></i> My Orders
                      </NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer to="/" id="LogOut">
                      <NavDropdown.Item onClick={logoutHandler}>
                        <i className="fas fa-sign-out-alt"></i> Logout
                      </NavDropdown.Item>
                    </LinkContainer>
                  </NavDropdown>
                ) : (
                  <LinkContainer to="/login" id="Login">
                    <Nav.Link className="enhanced-nav-link">
                      <i className="fas fa-user"></i>Sign In
                    </Nav.Link>
                  </LinkContainer>
                )}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>
      <Container>
        {/* ------------------------home how to create e-commerce----------- */}
        <section id="home">
          <Row className="p-2 align-items-center">
            <Col xs={12} md={8} lg={8}>
              <h3 className="retailHeading hero-heading" style={{ color: "#01584d" }}>
                Food &amp; groceries, delivered — <b>all in one app</b>
              </h3>
              <p className="finecart-hero-desc">
                finecart is your all-in-one super app for food and grocery delivery.
                Order meals from your favourite restaurants and daily essentials from
                trusted local stores — fresh produce, dairy, snacks, household and
                personal care — all from a single app. Real-time order tracking,
                secure payments and flexible delivery slots make ordering effortless,
                right from your phone.
              </p>
            </Col>
            <Col xs={12} md={4} lg={4} className="retailBtn mt-2">
              <a
                className="float-end mt-3 retailBtn demo-app-btn finecart-cta"
                href="https://onelink.to/5bxxyd"
                target="_blank"
                rel="noreferrer"
              >
                Download App <BsPhone size={20} />
              </a>
            </Col>
          </Row>

          {/*   <!-- -----------------About US ------------ --> */}
          <section style={{ color: "black" }} id="about">
            <Row className="row">
              <Col sm={12} xs={12} md={12} lg={6} className="mb-2 p-4 d-flex justify-content-center align-items-center">
                <div className="ratio ratio-4x3" style={{ width: "100%", maxWidth: "500px" }}>
                  <iframe
                    title="About Our Company"
                    src="https://www.youtube.com/embed/4j4kizoMPkI"
                    allowFullScreen
                    style={{
                      width: "100%",
                      height: "100%",
                      border: 'none',
                      borderRadius: '12px 12px 12px 9px',
                      overflow: 'hidden'
                    }}
                  />
                </div>
              </Col>
              <Col xs={12} md={12} lg={6} className="mb-2 p-4 d-flex justify-content-center align-items-center">
                <img style={{
                  width: "100%",
                  height: "94%",
                  border: 'none',
                  borderRadius: '12px 12px 12px 9px',
                  overflow: 'hidden'
                }} src={img} alt="img" />
              </Col>
            </Row>
          </section>

        </section>

        {/* ---------------- Campus Commerce highlight ---------------- */}
        <section id="campus" className="campus-commerce">
          <div className="campus-commerce-header">
            <span className="campus-eyebrow">Campus Commerce Platform</span>
            <h3 className="campus-title">
              Connecting students, parents &amp; schools
            </h3>
            <p className="campus-subtitle">
              Beyond delivery, finecart powers campus commerce — bringing
              students, parents and schools together with in-app calling, a
              shared wallet and built-in governance.
            </p>
          </div>
          <Row className="campus-grid">
            <Col xs={12} md={4} className="mb-3 d-flex">
              <div className="campus-card">
                <div className="campus-card-icon">
                  <i className="fas fa-phone-volume"></i>
                </div>
                <h5>Calling</h5>
                <p>
                  Secure in-app voice calls that connect parents and students
                  directly — no phone numbers shared.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} className="mb-3 d-flex">
              <div className="campus-card">
                <div className="campus-card-icon">
                  <i className="fas fa-wallet"></i>
                </div>
                <h5>Wallet</h5>
                <p>
                  A shared campus wallet parents top up and students spend, with
                  every transaction tracked in real time.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} className="mb-3 d-flex">
              <div className="campus-card">
                <div className="campus-card-icon">
                  <i className="fas fa-shield-alt"></i>
                </div>
                <h5>Governance</h5>
                <p>
                  Role-based controls, spending limits and audit trails give
                  schools full oversight and accountability.
                </p>
              </div>
            </Col>
          </Row>
        </section>

        {/*   <!-- -----------------How partner  ------------ --> */}
        <section style={{ color: "black" }} id="about">
          <div style={style.textcenter}>
            <span className="retailpara" style={{ color: "#000" }}>
              Create a seller account
            </span>
            <span style={style.separator}></span>
          </div>

          <section className="container mt-2 mb-5">
            {/*   <div style={style.textcenter}>
              <span className="retailpara" style={{ color: "#000" }}>
                Create your mobile friendly e-store within 24 hour
                <b>
                  <BsStopwatchFill size={20} />{" "}
                </b>{" "}
              </span>
              <span style={style.seperator}></span>
            </div> */}
            <Row className="row" style={{ justifyContent: "space-evenly" }}>
              {userInfo ? (
                <Col xs={12} md={6} lg={4} className="mb-3">
                  <span>Step 1</span>
                  <div className="border  p-3 cardHead">
                    <h2 style={style.info}>
                      <strong>Logged In</strong>
                    </h2>

                    <div className="d-grid gap-1 col-11 mx-auto">
                      <a
                        className="btn btn-secondary buttonStyle disabledLogin"
                        href="/login"
                      >
                        Logged In
                      </a>
                    </div>
                  </div>
                </Col>
              ) : (
                <Col xs={12} md={6} lg={4} className=" mb-3">
                  <span>Step 1</span>
                  <div className="border  p-3 cardHead">
                    <h2 style={style.info}>
                      <strong>Login</strong>
                    </h2>

                    <div className="d-grid gap-1 col-11 mx-auto">
                      <a
                        className="btn btn-secondary buttonStyle"
                        href="/login"
                      >
                        Login
                      </a>
                    </div>
                  </div>
                </Col>
              )}
              <Col xs={12} md={6} lg={4} className="mb-3">
                <span> Step 2</span>
                <div className="border p-3 cardHead">
                  <h2 style={style.info}>
                    <strong>Fill in your details</strong>
                  </h2>

                  <div className="d-grid gap-1 col-11 mx-auto">
                    <a
                      className="btn btn-secondary buttonStyle"
                      href="/onboard"
                    >
                      Onboarding
                    </a>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} className="mb-3">
                <span> Step 3</span>
                <div className="border p-3 cardHead">
                  <h2 style={style.sellInfo}>
                    <strong>
                      Set up discounts, banners, and logo with our Customer
                      Success Team{" "}
                    </strong>
                  </h2>
                </div>
              </Col>
            </Row>
          </section>

        </section>
        {/* <!--------------------service section----------------------> */}
        <section section className="container mt-5 mb-5" id="service">
          <div style={style.textcenter}>
            <span className="retailpara" style={{ color: "#000" }}>
              Pricing
            </span>
            <span style={style.separator}></span>
            {/*  <!-- <h1>Drop Us a Mail</h1>--> */}
          </div>
          <Row className="row" style={{ justifyContent: "space-evenly" }}>
            <Col sm={12} xs={12} md={6} lg={4} className="mb-3">
              <div className="border pt-3 pb-3 cardHead">
                <h2 style={style.card} className="plan-title">
                  <strong>Standard</strong>
                </h2>
                <ul className="card-text">
                  <li>
                    Billing <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>
                    Inventory <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>
                    Order Management <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>Kiosk</li>
                  <li>Multi desk (counter)</li>
                  <li>Accounting</li>
                  <li>Analytics</li>
                  <li>Online marketing</li>
                  <li>Email support or call</li>
                  <li>24x7 support</li>
                  <li>3000 Orders  <i className="fas fa-check fasCheck"></i></li>
                  <li>Price:  <span > ₹ 3000/year</span>  <i className="fas fa-check fasCheck"></i></li>
                </ul>
                <div className="d-grid gap-1 col-11 mx-auto">
                  <a className="btn btn-secondary buttonStyle" href="#contact">
                    Contact us
                  </a>
                </div>
              </div>
            </Col>
            <Col sm={12} xs={12} md={6} lg={4} className="mb-3">
              <div className="border pt-3 pb-3 cardHead">
                <h2 style={style.card}>
                  <strong>Pro</strong>
                </h2>

                <ul className="card-text">
                  <li>
                    Billing <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>
                    Inventory <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>
                    Order Management <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>
                    Kiosk <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>
                    Multi-desk (counter){" "}
                    <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>
                    Accounting <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>
                    Analytics <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>Online marketing</li>
                  <li>Email support or call</li>
                  <li>24x7 support</li>
                  <li>15,000 Orders  <i className="fas fa-check fasCheck"></i></li>
                  <li>Price:  <span > ₹ 10,000/year</span>  <i className="fas fa-check fasCheck"></i></li>
                </ul>
                <div className="d-grid gap-1 col-11 mx-auto">
                  <a className="btn btn-secondary buttonStyle" href="#contact">
                    Contact us
                  </a>
                </div>
              </div>
            </Col>
            <Col sm={12} xs={12} md={6} lg={4} className="mb-3">
              <div className="border pt-3 pb-3 cardHead">
                <h2 style={style.card}>
                  <strong> Enterprise</strong>
                </h2>
                <ul>
                  <li>
                    Billing <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>
                    Inventory <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>
                    Order Management <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>
                    Kiosk <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>
                    Multi-desk (counter){" "}
                    <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>
                    Accounting <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>
                    Analytics <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>
                    Online marketing <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>
                    Email support or call{" "}
                    <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>
                    24x7 support <i className="fas fa-check fasCheck"></i>
                  </li>
                  <li>More than 10 lakh orders  <i className="fas fa-check fasCheck"></i></li>
                  <li>Call us  <i className="fas fa-check fasCheck"></i></li>
                </ul>
                <div className="d-grid gap-1 col-11 mx-auto">
                  <a className="btn btn-secondary buttonStyle" href="#contact">
                    Contact us
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </section>
        {/* <!--FORM SECTION--> */}
        <div id="contact">
          <section style={style.section1} className="section1 clearfix">
            <div style={style.textcenter}>
              <span className="retailpara" style={{ color: "#000" }}>
                Contact us
              </span>
              <span style={style.separator}></span>
            </div>
          </section>

          <section className="section2 clearfix">
            <div className="col2 column2 first">
              <div className="sec2contactform">
                <h3 className="sec2frmtitle">
                  Want to know more? Drop us an email
                </h3>

                <Form onSubmit={submitHandler}>
                  <div className="clearfix">
                    <input
                      className="col2 first"
                      value={fname}
                      required
                      onChange={(e) => setFname(e.target.value)}
                      type="text"
                      placeholder="First name*"
                    />
                    <input
                      className="col2 last"
                      value={lname}
                      required
                      onChange={(e) => setLname(e.target.value)}
                      type="text"
                      placeholder="Last name*"
                    />
                  </div>
                  <div className="clearfix">
                    <input
                      className="col2 first"
                      value={email}
                      required
                      onChange={(e) => setEmail(e.target.value)}
                      type="email"
                      placeholder="Email Address*"
                    />
                    <input
                      className="col2 last"
                      value={number}
                      required
                      onChange={(e) => setNumber(e.target.value)}
                      type="text"
                      placeholder="Contact Number*"
                    />
                  </div>
                  <div className="clearfix">
                    <textarea
                      placeholder="Your message here..."
                      value={area}
                      onChange={(e) => setArea(e.target.value)}
                      cols="30"
                      rows="7"
                    ></textarea>
                  </div>
                  <div>
                    <input type="submit" value="Submit" />
                  </div>
                </Form>
                <MyVerticallyCenteredModal
                  show={modalShow}
                  onHide={() => setModalShow(false)}
                />
              </div>
            </div>

            <div className="col2 column1 last">
              <div className="mapouter">
                <div className="gmap_canvas">
                  <iframe
                    title="company location"
                    className="gmap_iframe"
                    width="100%"
                    scrolling="no"
                    src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=mufeed product and services chitguppa&amp;t=k&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                  ></iframe>
                </div>
              </div>
            </div>
          </section>
        </div>
      </Container>
      {/* ---------------- Download the app (App Store + Play Store) ---------------- */}
      <section id="download" className="finecart-download">
        <div className="finecart-download-badge">
          <BsPhone size={20} /> <strong>10K+</strong> downloads
        </div>
        <h4 className="finecart-download-title">Get the finecart app</h4>
        <div className="finecart-store-btns">
          <a
            className="finecart-store-btn"
            href="https://onelink.to/5bxxyd"
            target="_blank"
            rel="noreferrer"
            aria-label="Download finecart on the App Store"
          >
            <i className="fab fa-apple"></i>
            <span>
              <small>Download on the</small>
              App Store
            </span>
          </a>
          <a
            className="finecart-store-btn"
            href="https://onelink.to/5bxxyd"
            target="_blank"
            rel="noreferrer"
            aria-label="Get finecart on Google Play"
          >
            <i className="fab fa-google-play"></i>
            <span>
              <small>GET IT ON</small>
              Google Play
            </span>
          </a>
        </div>
      </section>
      {/*  <!-- Footer --> */}
      <section id="about">
        <footer
          className="text-center text-lg-start text-muted mt-5"
          style={{ backgroundColor: "#DADADA" }}
        >
          <div className="container text-center text-md-start ">
            {/* <!-- Right --> */}

            <Row className="row mt-3 ">
              {/*             <!-- Grid column -->
               */}{" "}
              <Col sm={12} xs={12} md={6} lg={4} className="mx-auto ">
                {/*               <!-- Content -->
                 */}{" "}
                <h6 className="text-uppercase fw-bold mb-2  mt-4 colorHeading">
                  <i className="fas fa-gem me-3"></i>Company Details
                </h6>
                <p className="color">
                  We are a registered startup under the Startup India program with
                  a focus on innovative solutions to help not just enterprises but
                  local businesses as well
                </p>
              </Col>
              <Col sm={12} xs={12} md={6} lg={2} className="mx-auto mb-4">
                {/*               <!-- Links -->
                 */}{" "}
                <h6 className="text-uppercase fw-bold mb-2 mt-4 colorHeading">
                  Products and Services
                </h6>
                <p>
                  <a href="#service" className="color">
                    Standard
                  </a>
                </p>
                <p>
                  <a href="#service" className=" color">
                    Pro
                  </a>
                </p>
                <p>
                  <a href="#service" className=" color">
                    Enterprise
                  </a>
                </p>
              </Col>
              {/*             <!-- Grid column -->
               */}
              {/*             <!-- Grid column -->
               */}{" "}
              <Col sm={12} xs={12} md={6} lg={3} className="mx-auto mb-4">
                {/*               <!-- Links -->
                 */}{" "}
                <h6 className="text-uppercase fw-bold mb-2 mt-4 colorHeading">
                  Contact us
                </h6>
                <p>
                  <a
                    className="fas fa-home me-3 color"
                    href="https://www.google.com/maps/place/MUFEED+PRODUCTS+AND+SERVICES/@17.698906,77.216225,6710m/data=!3m1!1e3!4m5!3m4!1s0x0:0xf7ce44c862937587!8m2!3d17.6989027!4d77.2162992?hl=en"
                  >
                    {" "}
                    Chitguppa, 585412, India
                  </a>
                </p>
                <p>
                  <a
                    href="mailto:hr@finecart.in"
                    className="fas fa-envelope me-3 color"
                  >
                    {" "}
                    hr@finecart.in
                  </a>
                </p>
                <p>
                  <a
                    href="tel:+918861710458"
                    className="fas fa-phone me-3 color"
                  >
                    {" "}
                    +918861710458{" "}
                  </a>
                </p>
              </Col>
              <Col sm={12} xs={12} md={6} lg={3} className="mx-auto mb-4">
                {/*               <!-- Links -->
                 */}{" "}
                <h6 className="text-uppercase fw-bold mb-2 mt-4  colorHeading">
                  Social media
                </h6>
                <div>
                  <div
                    style={{
                      display: "inline-block",
                      marginRight: "0.7rem",
                      textAlign: "center",
                    }}
                  >
                    <a
                      className="btn btn-secondary btn-floating  "
                      rel="noreferrer"
                      target="_blank"
                      style={{ backgroundColor: "#3b5998" }}
                      href="https://www.facebook.com/finecartapp/"
                      role="button"
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <div>
                      <span>Facebook</span>
                    </div>
                  </div>

                  <div
                    style={{
                      display: "inline-block",
                      marginRight: "0.7rem",
                      textAlign: "center",
                    }}
                  >
                    <a
                      className="btn btn-secondary btn-floating  "
                      rel="noreferrer"
                      target="_blank"
                      style={{ backgroundColor: "#55acee" }}
                      href="https://twitter.com/mufeez1"
                      role="button"
                    >
                      <i className="fab fa-twitter"></i>
                    </a>
                    <div>
                      <span>Twitter</span>
                    </div>
                  </div>

                  <div
                    style={{
                      display: "inline-block",
                      marginRight: "0.7rem",
                      textAlign: "center",
                    }}
                  >
                    <a
                      className="btn btn-secondary btn-floating "
                      rel="noreferrer"
                      target="_blank"
                      style={{ backgroundColor: "#0082ca" }}
                      href="https://www.linkedin.com/in/mufeezahmed/"
                      role="button"
                    >
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                    <div> LinkedIn</div>
                  </div>

                  <div
                    style={{
                      display: "inline-block",
                      marginRight: "0.7rem",
                      textAlign: "center",
                    }}
                  >
                    <a
                      className="btn btn-secondary  btn-floating "
                      rel="noreferrer"
                      target="_blank"
                      style={{ backgroundColor: "#211", borderRadius: "50%" }}
                      href="https://github.com/Mufeez"
                      role="button"
                    >
                      <i className="fab fa-github"></i>
                    </a>
                    <div> GitHub</div>
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col
                xs={12}
                sm={12}
                md={11}
                lg={12}
                xl={12}
                className="footerStyle"
              >
                <p>
                  {" "}
                  Copyright &copy; Huzaifa Software Solutions Private Limited{" "}
                </p>
              </Col>
            </Row>
          </div>
        </footer>
      </section>
      {/*     <!-- -----js bootstap----- -->
       */}{" "}
      <script
        src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js"
        integrity="sha384-MrcW6ZMFYlzcLA8Nl+NtUVF0sA7MsXsP1UyJoMp4YLEuNSfAP+JcXn/tWtIaxVXM"
        crossOrigin="anonymous"
      ></script>
    </div>
  );
};

export default AboutUs;

const style = {
  textcenter: {
    textAlign: "center",
  },
  cardHead: {
    borderRadius: "1px solid #000",
    li: {
      fontSize: "20px",
    },
  },
  card: {
    textAlign: "center",
    color: "#01584d",
    fontFamily: "merriweather, sans-serif",
  },
  info: {
    fontSize: "1.5rem",
    textAlign: "center",
    color: "#01584d",
    fontFamily: "merriweather, sans-serif",
  },
  sellInfo: {
    fontSize: "1.5rem",
    textAlign: "center",
    color: "#000",
    fontFamily: "merriweather, sans-serif",
  },
  separator: {
    borderBottom: "1px solid #a2a2a2",
    width: "35px",
    display: "inline-block",
    margin: "5px 30px 30px 30px",
  },
  section1: {
    textAlign: "center",
    display: "table",
    width: "100%",
    ".clearfix:before,\n.clearfix:after": { display: "table", content: "''" },
    ".clearfix:after": { clear: "both" },
  },
  clearfix: {
    ".clearfix:before,\n.clearfix:after": { display: "table", content: "''" },
    ".clearfix:after": { clear: "both" },
  },
};
